__turbopack_context__.v({
  "expandButton": "CanvasEmbedZoomControls-module__nvaGza__expandButton",
  "fitViewButton": "CanvasEmbedZoomControls-module__nvaGza__fitViewButton",
  "wrapper": "CanvasEmbedZoomControls-module__nvaGza__wrapper",
  "zoomControls": "CanvasEmbedZoomControls-module__nvaGza__zoomControls",
  "zoomInButton": "CanvasEmbedZoomControls-module__nvaGza__zoomInButton",
  "zoomNumber": "CanvasEmbedZoomControls-module__nvaGza__zoomNumber",
  "zoomOutButton": "CanvasEmbedZoomControls-module__nvaGza__zoomOutButton",
});
